module.exports = __webpack_public_path__ + "static/img/example_item.67f1f96d.png";